// removed by extract-text-webpack-plugin
module.exports = {"selectContainer":"_1eiPPVQSONQarJoyYmKvRQ","select":"_3G-VrkWrmX_PpW6K-H7Psg","selectGlyph":"_3htFtKpKppdCE1zohPgrR3","md":"_3gR9g_n8qnMDAeVE1kCOp6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisSelect.scss
// module id = 1141
// module chunks = 0